/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_No_AccountInputs */

const en_common_sign_no_account = /** @type {(inputs: Common_Sign_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't have an account?`)
};

/**
* | output |
* | --- |
* | "Don't have an account?" |
*
* @param {Common_Sign_No_AccountInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_sign_no_account = /** @type {((inputs?: Common_Sign_No_AccountInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_No_AccountInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_sign_no_account(inputs)
});
export { common_sign_no_account as "common.sign.no_account" }